import { render } from "./AgregarPersona.vue?vue&type=template&id=b5a8fa50"
import script from "./AgregarPersona.vue?vue&type=script&lang=js"
export * from "./AgregarPersona.vue?vue&type=script&lang=js"

import "./AgregarPersona.vue?vue&type=style&index=0&id=b5a8fa50&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__